<template lang="pug">
  .blog.has-text-left
    h2.title NEWS
    div(v-if="posts.length")
      carousel(:loop="true", :autoplay="true", :navigationEnabled="true", :perPage="1", :autoplayTimeout="4000", paginationActiveColor="#01a5e8")
        slide(v-for="(v, k) of posts.slice(0, 3)", :key="k")
          router-link.slide-content(:to="`/blog/${v.id}`", :style="{'background-image': `url(\"${v.feature}\")`}")
            div.column.is-full(style="position:relative;")
              h2.title.has-text-white.is-uppercase {{v.title}}
              p.has-text-weight-normal.has-text-white.is-hidden-mobile {{v.synopsis}}
              .details-bar.has-text-white.columns.is-multiline
                span.emphasized-text.column.is-half(style="flex: 1") {{v.category}}
                span.time.column.is-half
                  fa-icon(icon="clock")
                  span(style="margin-left:5px;") {{v.revealDate}}
    .filter-bar
      .type-options.is-flex
        label
          input.is-hidden(type="radio", name="newstype", checked, v-model='category', value="")
          .type-option.is-uppercase All news
        label(v-for="(v, k) of categories", :key="k")
          input.is-hidden(type="radio", name="newstype", v-model='category', :value="v.Name.toLowerCase()")
          .type-option.is-uppercase {{v.Name}}
        .paddingElem
        v-select(:options="months" v-model="filMonth" :reduce="data => data.value" :clearable="false"
          :searchable="false" placeholder="Month")
        v-select(:options="years" v-model="filYear" :reduce="data => data.value" :clearable="false"
          :searchable="false" placeholder="Year")
    .blog-articles.columns.is-multiline.is-4
      .column.is-full-mobile.is-half-tablet.is-one-third-desktop(v-for="(v, k) of filteredPosts", :key="k")
        BlogArticle(style="margin-bottom: 0; height: 100%;", :v="v")
    .load-more-posts
      button.button.load-more-posts-button.is-uppercase.is-primary(type="button", @click.prevent="loadMorePosts") MORE POSTS

</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import { Carousel, Slide } from 'vue-carousel'
  import BlogArticle from '@/components/BlogArticle.vue'

  export default {
    components: {
      BlogArticle,
      Carousel,
      Slide
    },
    data() {
      return {
        posts: [],
        categories: [],
        category: '',
        page: 0,
        filMonth: null,
        filYear: null,
        smallDate: 2015
      }
    },
    async mounted() {
      this.loadMorePosts()
      this.categories = (await this.$http.get(`${process.env.VUE_APP_BACKEND_URL}categories`)).data
    },
    computed: {
      months() {
        const temp = [];
        for (let i = 0; i < 12; i++) {
          temp.push({value: moment().month(i).format('MM'), label: moment().month(i).format('MMM')});
        }
        return temp
      },
      years() {
        const temp = [];
        for (let i = moment().format('YYYY'); i >= this.smallDate; i--) {
          temp.push({value: i, label: i});
        }
        return temp
      },
      filteredPosts() {
        return this.posts.filter(v => ((this.category === '' || v.category.toLowerCase() === this.category) && (!this.filMonth || Number(this.filMonth) === Number(moment(v.revealDate).format('MM'))) && (!this.filYear || Number(this.filYear) === Number(moment(v.revealDate).format('YYYY')))))
      }
    },
    methods: {
      isEmpty: _.isEmpty,
      async loadMorePosts() {
        const resp = (await this.$http.get(`${process.env.VUE_APP_BACKEND_URL}blogs?_page=${this.page++}`)).data

        this.posts = this.posts.concat(_.map(
          resp,
          value => ({
            id: value.id,
            revealDate: moment(value['Reveal Date'])
              .format('MMM D, YYYY'),
            category: value.category?.Name,
            categoryId: value.category?.id,
            // content: marked(value.content),
            feature: `${process.env.VUE_APP_BACKEND_URL}${value.feature.url.substring(1)}`,
            synopsis: value.synopsis,
            title: value.title
          })
        ))

        // Set year for filter
        this.smallDate = _.min(_.transform(this.posts, (result, n) => {
          result.push(moment(n.revealDate).format('YYYY'))
        }, []))
      }
    }
  }
</script>

<style lang="scss">
  @import "../styles/variables";
  @import "~bulma/sass/utilities/mixins";
  @import "../vue-select-corrected";

  .paddingElem {
    margin: auto;
    padding: auto;
  }

  .slide-content {
    display: flex;
    align-items: flex-end;
    position: relative;
    height: 450px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 3rem;

    &::before {
      content: '';
      position: absolute;
      background-color: rgba(80, 80, 80, 0.2);
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    .title {
      color: $white !important;
    }

    .details-bar {
      margin-top: 0;
      .time {
        text-align: right;
      }
    }
  }

  .blog {
    padding: 3rem;
    display: flex;
    flex-direction: column;

    .has-text-underlined {
      text-decoration: underline;
    }

    .emphasized-text {
      white-space: nowrap;
      font-weight: bold;
      text-decoration: underline;
    }

    .filter-bar {

      .type-options {
        @include until($desktop) {
          text-align: center;
          display: flex;
          flex-direction: column;
        }

        input[type=radio]:checked + .type-option {
          background-color: $secondary-colour;
          color: #FFF;
          font-weight: bold;
        }

        .type-option {
          flex-direction: row;
          font-weight: normal;
          align-items: baseline;
          padding: 0.5rem 3rem;
          cursor: pointer;
          transition: background-color 100ms;

          &:hover {
            background-color: lighten($secondary-colour, 80%);
          }
        }
      }
    }

    .ml-desk-auto {
      @include from($tablet) {
        margin-left: auto;
      }
    }
    .ml-desk-10 {
      @include from($tablet) {
        margin-left: 10px;
      }
    }

.load-more-posts {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 1.25rem;

      .load-more-posts-button {
        border-radius: 0;
        padding: 1.25rem 3rem;
        line-height: 0;
      }
    }
  }

</style>
